<template>
  <div class="profile-card">
    <slot name="icon">
      <i v-if="!picture" :class="icon" class="bx-md"> </i>
      <img v-else width="100" height="100" :src="picture" alt="Profile picture" class="mt-3 mb-2" />
    </slot>
    <h4>
      {{ title }}
    </h4>
    <slot />
    <div class="buttons" :style="computeStyle">
      <slot name="buttons"></slot>
      <h-b-action-rounded
        v-if="modifyFunction"
        icon="bx bx-edit-alt bx-xs"
        color="white"
        name="Modifier"
        @click.native="modifyFunction"
      >
      </h-b-action-rounded>
      <h-b-action-rounded
        v-if="deleteFunction"
        icon="bx bx-trash-alt bx-xs"
        color="white"
        name="Supprimer"
        @click.native="deleteFunction"
      >
      </h-b-action-rounded>
      <div v-if="archive">
        <h-b-action-rounded
          v-if="!archived"
          icon="bx bx-archive-in bx-xs"
          color="white"
          name="Archiver"
          @click.native="archiveFunction"
        >
        </h-b-action-rounded>
        <h-b-action-rounded
          v-if="archived"
          icon="bx bx-archive-out bx-xs"
          color="white"
          name="Retirer des archives"
          @click.native="unArchiveFunction"
        >
        </h-b-action-rounded>
      </div>
    </div>
  </div>
</template>

<script>
import HBActionRounded from '../buttons/action-rounded'

export default {
  name: 'profile-card',

  components: {
    HBActionRounded,
  },

  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    deleteFunction: {
      type: [Function, Boolean],
      default: null,
    },
    modifyFunction: {
      type: [Function, Boolean],
      default: null,
    },
    archive: {
      type: Boolean,
      default: false,
    },
    archived: {
      type: Boolean,
      default: false,
    },
    archiveFunction: {
      type: [Function, Boolean],
      default: () => ({}),
    },
    unArchiveFunction: {
      type: [Function, Boolean],
      default: () => ({}),
    },
    picture: {
      type: String,
      default: '',
    },
    buttonWidth: {
      type: String,
      default: '60',
    },
  },

  computed: {
    computeStyle() {
      if (this.archive) {
        return 'width : 100px'
      }
      return `width : ${this.buttonWidth}px`
    },
  },
}
</script>

<style scoped></style>
